import React, { Component } from 'react';

// const features = [
//     "floor area ratio",
//     "ratio of street surface to building area",
//     "cop",
//     "load score",
//     "chiller utilization",
//     "percentage of water body",
//     "score",
//     "cooling demand",
//     "building mix diversity",
//     "constructability score",
//     "vegetation coverage",
//     "cooling degree days",
//     "economics",
//     "peak load",
// ]

const features = [
    "score",
    "floor area ratio",
    "building mix diversity",
    "peak load",
    "economics",
    "cop",
    "chiller utilization",
    "cooling demand",
    "vegetation coverage",
    "waterbody coverage",
    "ratio of street surface to building area",
    "cooling degree days",
]

class Features extends Component {

    render() {
        if (JSON.stringify(this.props.features) != "{}") {
            const result = [];
            for (let key of features) {
                result.push({ key: key, value: this.props.features[key] ? this.props.features[key]: null})
            }
            return (
                <div className="Features">
                    <div className="SectionTitle" >Features</div>
                    <div className="SectionContent" >
                        {result.map(x => (
                            <div className="FeatureItem">
                                <div className="Name">{x.key}</div>
                                {/* <div className="Value">{x.value ? x.value : "0"}</div> */}
                                <div className="Value">{x.value ? (x.value > 10000 ? x.value.toExponential(2) : x.value.toFixed(2)) : "0"}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="Features">
                    <div className="SectionTitle" >Features</div>
                    <div className="SectionInstruction">
                        {this.props.mode == 'grid' ? <div>Please select a district...</div> : <div>Please use lasso tool to draw the boundary of a district...</div>}
                    </div>
                </div>
            )
        }

    }
}

export default Features
